import type { FieldDefinition } from '@src/utils/fieldDefinitionUtils';

export const repoFieldDefinitions = {
  leg: {
    title: 'Leg',
    tooltip: 'Order for the legs in a multi-leg instrument',
  },
  productTemplate: {
    title: 'Product Template',
    tooltip: 'Product template descriptive symbol',
  },
  suffix: {
    title: 'Suffix',
    tooltip: 'Optional tag to append to symbol, differentiating different product templates',
  },
  productDetails: {
    title: 'Repo Fields',
    tooltip: 'Economic details for the repo being created',
  },
  repoAsset: {
    title: 'Repo Asset',
    tooltip: 'Asset sold on the opening leg and repurchased on the closing leg of the repo.',
    columnTooltip: 'The asset being sold and repurchased',
  },
  borrowedAsset: {
    title: 'Borrowed Asset',
    tooltip: 'Cash currency paid on the opening leg and returned, with repo interest, on the closing leg.',
    columnTooltip: 'Cash paid on opening leg, returned with interest on closing leg',
  },
  unitRepoAmount: {
    title: 'Unit Repo Amount',
    tooltip:
      'Base repo size. When pricing a repo trade, Talos assumes this unit size for reverse repo/repo amount. You can then create repos of any amount from it.',
  },
  termType: {
    title: 'Term Type',
    tooltip: 'Whether the repo has a fixed term (Fixed Term) or is open-ended (Open Term).',
  },
  term: {
    title: 'Term',
    tooltip: 'Length of term for the repo.',
  },
  dayCountConvention: {
    title: 'Day Count Convention',
    tooltip: 'Convention used to compute accrued repo interest.',
  },
} as const satisfies Record<string, FieldDefinition>;

export type RepoFieldKey = keyof typeof repoFieldDefinitions;
